export default __webpack_public_path__ + "static/media/Logo_NJA-Construction-final.7d1b2991.png";